import React, { useState } from 'react';
import { MODULES } from './landingCopy';

const PREVIEW_COUNT = 4;

const countLabel = (n) => `${n} ${n === 1 ? MODULES.countOne : MODULES.countMany}`;

// Accessible disclosure list (WAI-ARIA accordion pattern: a button inside each category heading). All categories
// are visible at once with a short description and a preview of their modules; opening one reveals every module
// with a one-line explanation. Categories open and close independently. No animation, no new dependency.
const ModuleExplorer = () => {
  const [open, setOpen] = useState(() => new Set());
  const toggle = (id) => setOpen((current) => {
    const next = new Set(current);
    if (next.has(id)) next.delete(id);
    else next.add(id);
    return next;
  });

  return (
    <section className="zl-modules" id="onderdelen" aria-labelledby="modules-title">
      <div className="zl-wrap">
        <div className="zl-modules-head">
          <p className="zl-eyebrow">{MODULES.eyebrow}</p>
          <h2 id="modules-title" className="zl-h2">{MODULES.title}</h2>
          <p>{MODULES.intro}</p>
        </div>
        <div className="zl-modules-list">
          {MODULES.groups.map((group) => {
            const isOpen = open.has(group.id);
            const preview = group.items.slice(0, PREVIEW_COUNT).map((item) => item.name);
            const rest = group.items.length - preview.length;
            return (
              <div key={group.id} className="zl-module-group" data-testid="module-group" data-open={isOpen ? 'true' : 'false'}>
                <h3>
                  <button
                    type="button"
                    id={`modules-btn-${group.id}`}
                    className="zl-mg-button"
                    aria-expanded={isOpen}
                    aria-controls={`modules-panel-${group.id}`}
                    onClick={() => toggle(group.id)}
                  >
                    <span className="zl-mg-main">
                      <span className="zl-mg-name">{group.name}</span>
                      <span className="zl-mg-desc">{group.description}</span>
                    </span>
                    <span className="zl-mg-side">
                      <span className="zl-mg-preview" data-testid="module-preview" hidden={isOpen}>
                        {preview.join(', ')}{rest > 0 ? ` +${rest}` : ''}
                      </span>
                      <span className="zl-mg-count">{countLabel(group.items.length)}</span>
                    </span>
                    <span className="zl-pm" aria-hidden="true" />
                  </button>
                </h3>
                <div id={`modules-panel-${group.id}`} role="region" aria-labelledby={`modules-btn-${group.id}`} className="zl-mg-panel" hidden={!isOpen}>
                  <ul>
                    {group.items.map((item) => (
                      <li key={item.name} data-module={item.module || undefined} data-testid="module-item">
                        <strong>{item.name}</strong>
                        <span>{item.text}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            );
          })}
        </div>
        <p className="zl-modules-note">{MODULES.note}</p>
      </div>
    </section>
  );
};

export default ModuleExplorer;
